import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import FileAccept from 'shared/components/file-portal/file-accept'
import InputWrapper from 'shared/components/inputs/file-input'
import { getUser, getUserLoggedIn, getUserPermissions } from 'shared/redux/reducers'
import { trackEvent, trackFileList, trackUrls } from 'shared/util/gif-maker-ga-events'
import { getError } from '../../../redux/error'
import getPreview from '../../finalize/upload/preview/get-preview'
import { withUploadContext } from '../../upload-context'
import LegacyInputButton from './button/button'
import FilePortalInputButton from './button/file-button.tsx'
import css from './upload.css'
import { UrlInputWrapperUpload } from './url-input/url-input'

const BROWSE = {
    title: 'Browse Your Files',
    icon: 'browse',
    description: 'Upload one or more GIFs.',
}

const DRAGNDROP = {
    title: 'Drag and Drop GIFs',
    icon: 'drag',
    description: 'Drop them right here, right now.',
}

const UPLOADGIF = {
    title: 'GIF',
    icon: 'gif',
    description: 'Upload one or more GIFs or images to decorate or combine.',
}

const UPLOADSTICKER = {
    title: 'Sticker',
    icon: 'sticker',
    description: 'Create stickers by uploading transparent GIFs.',
}

const UPLOADVIDEO = {
    title: 'Clip',
    icon: 'video',
    description: 'Upload clips with sound.',
}

const SUPER_CUT = {
    title: 'GIPHY Super Cut',
    icon: 'supercut',
    description: 'Automagically create a set of GIFs & Clips from a longer clip.',
    url: '/supercut',
}

@withUploadContext
@FileAccept
@connect(({ error, ...state }) => ({
    error: getError(error),
    isLoggedIn: getUserLoggedIn(state),
    user: getUser(state),
    userPermissions: getUserPermissions(state),
}))
class FilePortal extends PureComponent {
    state = {
        urlAccepted: false,
    }
    static propTypes = {
        fileTypes: PropTypes.array.isRequired,
        mimeTypes: PropTypes.array.isRequired,
        isCameraSupported: PropTypes.bool,
        isLoggedIn: PropTypes.bool,
        maxFilesize: PropTypes.number,
        maxDuration: PropTypes.number,
        onError: PropTypes.func,
        onFileAccepted: PropTypes.func.isRequired,
        user: PropTypes.object,
        userPermissions: PropTypes.object,
    }
    componentWillReceiveProps({ error }) {
        if (!isEmpty(error)) {
            this.setState({ urlAccepted: false })
        }
    }
    render() {
        const {
            fileTypes,
            maxDuration,
            maxFilesize,
            onError,
            onFileAccepted: doFileAccept,
            onPreviewReady,
            mimeTypes,
            user,
            userPermissions,
            checkLoginStatus,
            isLoggedIn,
        } = this.props
        const inputProps = {
            maxDuration,
            maxFilesize,
            onError,
            checkLoginStatus,
            isLoggedIn,
            allowMultipleVideos: true,
            allowMix: true,
            onFileAccepted: (...args) => {
                trackEvent('Input', 'Browse Files')
                trackFileList(...args)
                doFileAccept(...args)
            },
            className: css.fileButton,
        }
        const { urlAccepted } = this.state
        const hasSuperCutAccess = userPermissions.access_dvr || user.isStaff
        return (
            <div className={css.filePortal}>
                {user.isStaff || userPermissions.upload_videos ? ( // TODO: Add video beta group check here
                    <>
                    <div className={css.fileContainer}>
                        <InputWrapper {...inputProps} mimeTypes={mimeTypes} acceptMultiple={true}>
                            <FilePortalInputButton
                                label={UPLOADGIF.title}
                                description={UPLOADGIF.description}
                                icon={UPLOADGIF.icon}
                                isVertical={false}
                            />
                        </InputWrapper>
                        <InputWrapper {...inputProps} mimeTypes={mimeTypes} acceptMultiple={true}>
                            <FilePortalInputButton
                                label={UPLOADSTICKER.title}
                                description={UPLOADSTICKER.description}
                                icon={UPLOADSTICKER.icon}
                                isVertical={false}
                            />
                        </InputWrapper>
                        <InputWrapper {...inputProps} mimeTypes={mimeTypes} acceptMultiple={true}>
                            <FilePortalInputButton
                                label={UPLOADVIDEO.title}
                                description={UPLOADVIDEO.description}
                                icon={UPLOADVIDEO.icon}
                                isVertical={false}
                            />
                        </InputWrapper>
                    </div>
                    <div>
                        {hasSuperCutAccess && (
                            <a href={SUPER_CUT.url} className={css.fileButtonWide}>
                            <LegacyInputButton
                                label={SUPER_CUT.title}
                                description={SUPER_CUT.description}
                                icon={SUPER_CUT.icon}
                                isVertical={false}
                                isNew
                            />
                            </a>
                        )}
                    </div>
                    </>
                ) : (
                    <div className={css.fileContainer}>
                        <InputWrapper {...inputProps} mimeTypes={mimeTypes} acceptMultiple={true}>
                            <LegacyInputButton
                                label={BROWSE.title}
                                description={BROWSE.description}
                                icon={BROWSE.icon}
                                isVertical={false}
                            />
                        </InputWrapper>
                        <div className={css.fileButton}>
                            <LegacyInputButton
                                label={DRAGNDROP.title}
                                description={DRAGNDROP.description}
                                icon={DRAGNDROP.icon}
                                isVertical={false}
                            />
                        </div>
                    </div>
                )}

                <div className={css.ctaWrapper}>
                    <UrlInputWrapperUpload
                        {...{
                            urlAccepted,
                            fileTypes,
                            onError,
                            checkLoginStatus,
                            isLoggedIn,
                            onFileAccepted: async ([file], ...args) => {
                                this.setState({ urlAccepted: true })
                                // url input doesn't need preview for upload
                                const preview = await getPreview(file)
                                onPreviewReady([{ ...file, ...preview }])
                                trackUrls([file], ...args)
                                trackFileList([file], ...args)
                            },
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default FilePortal
